<template lang="pug">
div
	// Lid van NSkiV, toon felicitatie
	template(v-if="$store.getters.membershipType === 'nskiv'")
		h1.text-center.d-block.text-md-h3.text-h5.font-weight-bold.mb-2 Je bent lid van de Nederlandse Ski Vereniging!
		.club-content--center.mb-6
			video-hls(videoUrl="nskiv1Qdlt6ROQW")

		.text-center.mb-6
			v-btn.mb-6(color="primary" x-large depressed :to="localePath({name: 'profile-membership-benefits'})" )
				.text-h5.font-weight-bold mijn voordelen

	// Lid van Club, toon felicitatie, tenzij je op de nskiv-upgrade pagina zit
	template(v-else-if="$store.getters.membershipType === 'club' && $route.params.type !== 'nskiv'")

		h1.text-center.d-block.text-md-h3.text-h5.font-weight-bold.mb-2 Je bent lid van Club Wintersporters!
		.club-content--center.mb-6
			video-hls(videoUrl="nskiv1Qdlt6ROQW")

		.text-center.mb-6
			v-btn.mb-6(color="primary" x-large depressed :to="localePath({name: 'profile-membership-benefits'})" )
				.text-h5.font-weight-bold mijn voordelen
			br
			v-btn(color="accent" large text :to="localePath({name: 'memberships-type', params:{type:'nskiv'}})" ) Upgraden naar NSkiV Lidmaatschap


	// Lid van Club, nskiv-upgrade pagina
	template(v-else-if="$store.getters.membershipType === 'club' && $route.params.type === 'nskiv'")
		h1.d-block.text-md-h3.text-h5.font-weight-bold Upgraden naar het NSkiV Lidmaatschap

		p Vraag hier je upgrade aan, je ontvangt bericht van ons zodra je upgrade doorgevoerd is.
		validation-observer(v-slot="{ handleSubmit, invalid }" v-if="!upgradeRequested")
			form(@submit.prevent="handleSubmit(upgradeMember)")
				v-row.mb-6
					v-col(cols="12")
						validation-provider(v-slot="{errors}" :rules="{ required: { allowFalse: false } }" name="Akkoord geven op de upgrade" slim)
							v-checkbox( hide-details="auto" v-model="upgradeAccepted" :error-messages="errors")
								template(#label)
									div(@click.stop="") Ik wil upgraden naar het NSkiV lidmaatschap
					v-col(cols="12")
						validation-provider(v-slot="{errors}" :rules="{ required: { allowFalse: false } }" name="Akkoord geven op de voorwaarden" slim)
							v-checkbox( hide-details="auto" v-model="accept" :error-messages="errors")
								template(#label)
									div(@click.stop="") Hierbij machtig ik NSkiV BV om de jaarlijkse contributie van mijn rekening af te schrijven. Ik ben bekend en akkoord met de <a href="https://download.wintersport.nl/media/downloads/2022/11/14/lidmaatschap-algemene-voorwaarden-versie-2022-14-11-2022.pdf" target="_blank" >algemene voorwaarden</a> van het lidmaatschap. Daarnaast ga ik ermee akkoord dat mijn lidmaatschapsoverzicht en overige documenten en communicatie rondom mijn lidmaatschap elektronisch worden verstrekt.

				v-btn(color="primary" type="submit" :disabled="submitted" depressed)
					span(v-if="$route.params.type === 'nskiv'") Upgraden naar het NSkiV lidmaatschap
		p(v-else) Bedankt voor je aanvraag, we gaan voor je aan de slag!


	//- Niet ingelogd, geef een melding dat je een account nodig hebt
	template(v-else-if="!$store.getters.membershipType")
		h1.d-block.text-md-h3.text-h5.font-weight-bold Registreer je profiel op wintersport.nl
		//- h2 Je profiel op wintersport.nl
		p(v-if="$route.params.type === 'nskiv'") Tof dat je je wilt aansluiten bij de gezelligste vereniging van Nederland! Om de voordelen van het lidmaatschap te gebruiken en je lidmaatschap te beheren heb je een account nodig op wintersport.nl. Geen zorgen, een account voor wintersport.nl is altijd helemaal gratis, er wordt nu nog niets in rekening gebracht!
		p(v-if="$route.params.type === 'club'") Tof dat je je wilt aansluiten bij de gezelligste club van Nederland! Om de voordelen van het lidmaatschap te gebruiken en je lidmaatschap te beheren heb je een account nodig op wintersport.nl. Geen zorgen, een account voor wintersport.nl is altijd helemaal gratis, er wordt nu nog niets in rekening gebracht!
		p(v-if="$route.params.type === 'community'") Tof dat je je wilt aansluiten bij de gezelligste community van Nederland! Een account voor wintersport.nl is altijd helemaal gratis, je kunt later altijd nog upgraden naar een Club Wintersporters lidmaatschap of lid worden van de NSkiV.
		template(v-if="!$store.state.user.id")
			p Heb je al een account?
				login-action
					template(#activator="{ on }")
						a.ml-1(v-on="on") Log dan in met jouw account.

			validation-observer(v-slot="{ handleSubmit }")
				form(@submit.prevent="handleSubmit(submitRegister)")
					h2 {{$t('page.register:heading')}}
					v-row.mt-3(v-if="error.show")
						v-col(cols="12" md="6")
							v-alert.mb-3(:value="error.show" type="error" color="error") {{error.message}}
					v-row.mt-3
						v-col(cols="12" md="6")
							validation-provider(v-slot="{errors, touched}" rules="required|min:4|max:50" :name="$t('page.register:input.username')" slim)
								v-text-field(v-model="username" :label="$t('page.register:input.username')" outlined persistent-placeholder hide-details="auto" :error-messages="errors")
					v-row
						v-col(cols="12" md="6")
							validation-provider(v-slot="{errors, touched}" rules="required|email" :name="$t('page.register:input.email')" slim)
								v-text-field(v-model="email" :label="$t('page.register:input.email')" outlined persistent-placeholder hide-details="auto" :error-messages="errors")
					v-row
						v-col(cols="12" md="6")
							validation-provider(v-slot="{errors, touched}" rules="required|min:6" :name="$t('page.register:input.password')" slim)
								v-text-field(v-model="password" :append-icon="showPassword ? 'visibility' : 'visibility_off'" @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'" :label="$t('page.register:input.password')" outlined persistent-placeholder hide-details="auto" :error-messages="errors")
							.caption.my-3.text-center
								i18n(path="page.register:register.disclaimer_{url}")
									nuxt-link(to="/privacy-en-voorwaarden" target="_blank" slot="url") {{$t('page.register:privacy.policy.link')}}
					v-row.mb-6
						v-col(cols="12" md="6")
							v-btn(type="submit" color="primary" depressed) {{$t('page.register:submit.button')}}

	//- Wel ingelogd, formulier om aan te melden
	template(v-else)
		h1.d-block.text-md-h3.text-h5.font-weight-bold(v-if="$route.params.type === 'nskiv'") Meld je aan voor je NSkiV lidmaatschap
		h1.d-block.text-md-h3.text-h5.font-weight-bold(v-if="$route.params.type === 'club'") Meld je aan voor Club Wintersporters

		memberships-link

		validation-observer(v-slot="{ handleSubmit, invalid }")
			form(@submit.prevent="handleSubmit(submitMember)")
				h2 Persoonlijke gegevens
				v-row.mt-3
					v-col(cols="12")
						validation-provider(v-slot="{errors}" rules="required" :name="$t('page.club-wintersporters.naw:gender')" slim)
							v-radio-group(v-model="member.geslach" row)
								v-radio(:label="$t('page.club-wintersporters.naw:male')" value="M")
								v-radio(:label="$t('page.club-wintersporters.naw:female')" value="V")
					v-col(cols="4" md="2")
						validation-provider(v-slot="{errors}" rules="required" name="Voorletters" slim)
							v-text-field(label="Voorletters" placeholder=" " persistent-placeholder v-model.trim="member.voorl"  hide-details="auto" :error-messages="errors" outlined)
					v-col(cols="8" md="4")
						validation-provider(v-slot="{errors}" rules="required" :name="$t('page.club-wintersporters.naw:first_name')" slim)
							v-text-field(:label="$t('page.club-wintersporters.naw:first_name')" placeholder=" " persistent-placeholder v-model.trim="member.rnaam"  hide-details="auto" :error-messages="errors" outlined)
				v-row
					v-col(cols="4" md="2")
						validation-provider(v-slot="{errors}" :name="$t('page.club-wintersporters.naw:middle_name')" slim)
							v-text-field(:label="$t('page.club-wintersporters.naw:middle_name')" v-model.trim="member.voorv" placeholder=" " persistent-placeholder hide-details="auto"  :error-messages="errors" outlined)
					v-col(cols="8" md="4")
						validation-provider(v-slot="{errors}" rules="required" :name="$t('page.club-wintersporters.naw:last_name')" slim)
							v-text-field(:label="$t('page.club-wintersporters.naw:last_name')" v-model.trim="member.anaam" placeholder=" " persistent-placeholder hide-details="auto"  :error-messages="errors" outlined)
				v-row.mb-6
					v-col(cols="12" md="6")
						validation-provider(v-slot="{errors, touched}" :rules="{ required: true, regex: /^[0-3]?[0-9]-[0-1]?[0-9]-[1-2][0-9]{3}$/i ,adult: true }" :name="$t('page.club-wintersporters.naw:birthdate')" slim)
							v-text-field(:label="$t('page.club-wintersporters.naw:birthdate')" v-model="member.gebdat" persistent-placeholder hide-details="auto" :error-messages="touched ? errors : []" hint="Gebruik formaat DD-MM-JJJJ" placeholder="DD-MM-JJJJ" outlined)

				h2 Contactgegevens
				v-row.mt-3
					v-col(cols="12" md="6")
						validation-provider(v-slot="{errors}" rules="email" name="E-mailadres" slim)
							v-text-field(label="E-mailadres" hide-details="auto" disabled :value="$store.state.user.email" :error-messages="errors" outlined)

				v-row.mb-6
					v-col(cols="12" md="6")
						validation-provider(v-slot="{errors, touched}" :rules="{required:true, length:10, numeric: true}" name="Telefoonnummer" slim)
							v-text-field(label="Telefoonnummer" hide-details="auto" placeholder=" " persistent-placeholder v-model.trim="member.telnum" :error-messages="touched ? errors : []" outlined)

				h2 Adres
				v-row.mt-3
					v-col(cols="12" md="6")
						validation-provider(v-slot="{errors}" :rules="postalcodeRules" :name="$t('page.club-wintersporters.naw:postalcode')" slim)
							v-text-field(@input="fetchAddress()" :label="$t('page.club-wintersporters.naw:postalcode')" hide-details="auto" placeholder=" " persistent-placeholder v-model.trim="member.pcode" :error-messages="errors" outlined)
				v-row
					v-col(cols="8" md="4")
						validation-provider(v-slot="{errors}" rules="required|numeric" :name="$t('page.club-wintersporters.naw:house_number')" slim)
							v-text-field(@input="fetchAddress()" :label="$t('page.club-wintersporters.naw:house_number')" hide-details="auto" placeholder=" " persistent-placeholder v-model.trim="member.huisnr" :error-messages="errors" outlined)
					v-col(cols="4" md="2")
						v-text-field(:label="$t('page.club-wintersporters.naw:house_number_add')" v-model.trim="member.toevoeg" hide-details="auto" placeholder=" " persistent-placeholder outlined)
				v-row
					v-col(cols="12" md="6")
						validation-provider(v-slot="{errors}" rules="required" :name="$t('page.club-wintersporters.naw:street')" slim)
							v-text-field(:label="$t('page.club-wintersporters.naw:street')" v-model.trim="member.straat" hide-details="auto" placeholder=" " persistent-placeholder :disabled="lookupInProgress" :error-messages="errors" outlined)
				v-row.mb-6
					v-col(cols="12" md="6")
						validation-provider(v-slot="{errors}" rules="required" :name="$t('page.club-wintersporters.naw:city')" slim)
							v-text-field(:label="$t('page.club-wintersporters.naw:city')" v-model.trim="member.plaats" :disabled="lookupInProgress" hide-details="auto" placeholder=" " persistent-placeholder :error-messages="errors" outlined)

				h2 Betaalgegevens
				v-row.mt-3
					v-col(cols="12" md="6")
						validation-provider(v-slot="{errors}" rules="required|iban" name="IBAN rekeningnummer" slim)
							v-text-field(label="IBAN rekeningnummer" hide-details="auto" placeholder=" " persistent-placeholder v-model.trim="member.iban" :error-messages="errors" outlined)

				v-row.mb-6
					v-col(cols="12")
						validation-provider(v-slot="{errors}" :rules="{ required: { allowFalse: false } }" name="Akkoord geven op de voorwaarden" slim)
							v-checkbox( hide-details="auto" v-model="accept" :error-messages="errors")
								template(#label)
									div(@click.stop="") Hierbij machtig ik NSkiV BV om de jaarlijkse contributie van mijn rekening af te schrijven. Ik ben bekend en akkoord met de <a href="https://download.wintersport.nl/media/downloads/2022/11/14/lidmaatschap-algemene-voorwaarden-versie-2022-14-11-2022.pdf" target="_blank" >algemene voorwaarden</a> van het lidmaatschap. Daarnaast ga ik ermee akkoord dat mijn lidmaatschapsoverzicht en overige documenten en communicatie rondom mijn lidmaatschap elektronisch worden verstrekt.

				v-btn(color="primary" type="submit" :disabled="submitted" depressed)
					span(v-if="$route.params.type === 'nskiv'") NSkiV lidmaatschap aanvragen
					span(v-if="$route.params.type === 'club'") Club Wintersporters lidmaatschap aanvragen
				div.mt-4(v-if="submitted")
					v-progress-circular( indeterminate color="primary" size="20")
					span.ml-2.grey--text.text--darken-1 Het lidmaatschap wordt aangemaakt... Even geduld a.u.b.
				v-alert.mt-6(v-if="error.show" type="error" dense)
					span Het is helaas niet gelukt om het lidmaatschap aan te maken. Probeer het later nog eens.

</template>

<style lang="sass">

.club-content--center
	max-width: 1160px
	width: 100%
	margin: auto
	&.narrow
		max-width: 755px

.image-column
	.v-responsive__content
		display: flex
		flex-direction: column !important
</style>

<script>
import gql from 'graphql-tag';
import { validate, extend } from 'vee-validate';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import IBAN from 'iban';
import VideoHls from '@dengl/common/components/video-hls.vue';
import MembershipsLink from '@/components/memberships/link.vue';

extend('iban', {
	validate: value => {
		return IBAN.isValid(value);
	},
	message: fieldName => {
		return `${fieldName} is ongeldig.`;
	}
});

const registerMutation = gql`
	mutation (
		$username: String!
		$password: String!
		$email: String!
		$redirect: String
	) {
		signup(
			userData: {
				email: $email
				password: $password
				username: $username
				redirect: $redirect
			}
		)
	}
`;
export default {
	name: 'MembershipRegister',
	components: {
		MembershipsLink,
		VideoHls
	},
	middleware({ store, redirect, _app, route }) {
		if (route.params.type === 'community' && store.getters.membershipType) {
			return redirect('/profiel/lidmaatschap');
		}
	},
	validate({ params }) {
		return ['club', 'nskiv', 'community'].includes(params.type);
	},
	nuxtI18n: {
		paths: {
			'nl-NL': '/lidmaatschappen/lid-worden-:type',
			'nl-BE': '/lidmaatschappen/lid-worden-:type'
		}
	},
	asyncData({ app, route }) {
		const title = {
			nskiv: 'Lid worden van de Nederlandse Ski Vereniging',
			club: 'Lid worden van Club Wintersporters',
			community: 'Profiel aanmaken op wintersport.nl'
		}[route.params.type];

		app.ads({});
		app.meta({ title });
		app.breadcrumbs({
			Lidmaatschappen: {
				name: 'memberships'
			},
			[title]: {
				name: 'memberships-type',
				params: route.params
			}
		});
	},
	data() {
		return {
			submitted: false,
			accept: false,
			member: {},
			lookupInProgress: this.$i18n.locale !== 'nl-BE',
			addressRequestLoading: false,
			username: '',
			email: '',
			password: '',
			error: {
				show: false,
				message: null
			},
			showPassword: false,
			upgradeRequested: false,
			upgradeAccepted: false
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		postalcodeRules() {
			if (this.$i18n.locale === 'nl-BE') {
				return {
					required: true,
					regex: /^[1-9][0-9]{3}$/i
				};
			} else {
				return {
					required: true,
					regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
				};
			}
		}
	},
	created() {
		this.$dayjs.extend(customParseFormat);

		extend('adult', {
			validate: value => {
				const eighteenYear = this.$dayjs().subtract(18, 'year');

				return this.$dayjs(value, 'D-M-YYYY').isBefore(eighteenYear);
			},
			message: _fieldName => {
				return `Je moet minimaal 18 jaar oud zijn om lid te worden.`;
			}
		});
	},

	methods: {
		upgradeMember() {
			this.submitted = true;
			this.$graphClient
				.mutate({
					mutation: gql`
						mutation upgradeToNSkiVMembership(
							$input: upgradeToNSkiVMembershipInput!
						) {
							result: upgradeToNSkiVMembership(input: $input)
						}
					`,
					variables: {
						input: {
							email: this.$store.state.user.email
						}
					}
				})
				.then(({ data, _errors }) => {
					if (data.result) {
						this.upgradeRequested = true;
					} else {
						this.$toast.error('Er is iet fout gegaan');
					}
				})
				.catch(error => {
					this.$toast.error(error.message);
				})
				.finally(() => {
					this.submitted = false;
				});
		},
		submitMember() {
			if (this.submitted) {
				return;
			}
			this.submitted = true;
			const member = this.$lodash.cloneDeep(this.member);

			member.gebdat = this.$dayjs(member.gebdat, 'D-M-YYYY').format('YYYYMMDD');
			member.email = this.$store.state.user.email;

			const variables = {
				input: {
					policyholder: member
				}
			};

			const mutation =
				this.$route.params.type === 'nskiv'
					? gql`
							mutation RequestNSkiVMembership(
								$input: RequestNSkiVMembershipInput!
							) {
								result: RequestNSkiVMembership(input: $input) {
									success
								}
							}
					  `
					: gql`
							mutation RequestClubMembership(
								$input: RequestClubMembershipInput!
							) {
								result: RequestClubMembership(input: $input) {
									success
								}
							}
					  `;

			if (this.$route.params.type === 'nskiv') {
				variables.input.questionnaire = [
					{ id: '1E9BF5D0-072E-44C3-B196-13DBAC7E57A6', response: 'Ja' },
					{ id: '0D69E2C6-5CD7-4EAC-8F6C-F6254F1E32D6', response: 'Ja' }
				];
			}

			variables.input.policyholder.land =
				this.$i18n.locale === 'nl-BE' ? 'BE' : 'NL';

			this.$graphClient
				.mutate({
					mutation,
					variables
				})
				.then(({ data, errors }) => {
					if (errors && errors[0].message === 'user-has-existing-membership') {
						this.$toast.error('Je hebt al een lopend lidmaatschap');
						throw errors[0];
					}
					if (data.result && data.result.success) {
						window.location.reload();
					}
				})
				.catch(_error => {
					this.submitted = false;
					this.error.show = true;
					this.$toast.error('Oeps, er ging iets mis bij het opslaan');
				});
		},

		async fetchAddress() {
			if (this.$i18n.locale === 'nl-BE') {
				return;
			}

			const postalcode = await validate(this.member.pcode, {
				required: true,
				regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
			}).then(result => result.valid);

			const housenumber = await validate(
				this.member.huisnr,
				'required|numeric'
			).then(result => result.valid);

			if (postalcode && housenumber) {
				this.lookupInProgress = true;
				this.$graphClient
					.query({
						query: gql`
							query clubLookupAddress($postalcode: String, $housenumber: Int) {
								lookupAddress(
									postalcode: $postalcode
									housenumber: $housenumber
								) {
									postalcode
									housenumber
									street
									city
								}
							}
						`,
						variables: {
							postalcode: this.member.pcode,
							housenumber: parseInt(this.member.huisnr)
						},
						errorPolicy: 'all'
					})
					.then(({ data, _errors }) => {
						if (data.lookupAddress.street) {
							this.member.straat = data.lookupAddress.street;
							this.member.plaats = data.lookupAddress.city;
						}
						this.lookupInProgress = false;
					});
			}
		},

		submitRegister() {
			this.error = {
				show: false
			};
			this.$graphClient
				.mutate({
					mutation: registerMutation,
					variables: {
						email: this.email,
						password: this.password,
						username: this.username,
						redirect: window.location.href
					}
				})
				.then(({ data, errors }) => {
					if (errors) {
						if (errors.length > 0 && errors[0].message === 'marked.as.spam') {
							return (this.error = {
								show: true,
								message: this.$t(`page.register:error.${errors[0].message}`)
							});
						}

						this.error = {
							show: true,
							message: this.$t(`page.register:error.${errors[0].message}`)
						};
					}
					if (data.signup) {
						this.$router.push(this.localePath({ name: 'registerconfirm' }));
					}
				});
		}
	}
};
</script>
